import { NgModule } from '@angular/core';
import { ExampleNg6LibComponent } from './example-ng6-lib-prova.component';
import { FooComponent } from './foo/foo.component';
import { PrimoModule} from './primo/primo.module';
import { SecondoModule} from './secondo/secondo.module';
// import { CounterComponent } from './primo/counter/counter.component';

@NgModule({
  imports: [
    PrimoModule,
    SecondoModule
  ],
  declarations: [ExampleNg6LibComponent, FooComponent],
  exports: [ExampleNg6LibComponent, FooComponent]
})
export class ExampleNg6LibModule { }
